import axios from 'axios';

export function getDiseases(disease) {
    return axios
        .post('api/consulta-icd', { disease })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.error('Error en la solicitud:', error);
            throw error;
        });
}

export function postDisease(data) {
    return axios
        .post('/api/create-disease', { data })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.error('Error en la solicitud:', error);
            throw error;
        });
}
